import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  inject,
  output,
  ChangeDetectionStrategy,
} from "@angular/core";
import { FreightRateGroup } from "../freight-rate-group/freight-rate-group.model";
import { FclRoute } from "../../../route/route-fcl.model";
import { Route } from "../../../route/route-type";
import { ContainerPrices } from "../../../shared/container/container-prices.model";
import { ContainerName } from "../../../shared/container/container-name.type.const";
import { FclTier } from "../../../tier/tier-fcl.model";
import { SelectItem } from "primeng/api";
import { TierRepository } from "../../../tier/tier.repository";
import { Bind } from "primeng/bind";
import { ButtonDirective } from "primeng/button";
import { Select } from "primeng/select";
import { FormsModule } from "@angular/forms";
import { InputText } from "primeng/inputtext";
import { FormatContainerLabelPipe } from "../../../shared/container/format-container-label.pipe";

@Component({
  selector: "app-freight-rate-batch-margin",
  templateUrl: "./freight-rate-batch-margin.component.html",
  styleUrls: ["./freight-rate-batch-margin.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    ButtonDirective,
    Bind,
    Select,
    FormsModule,
    InputText,
    FormatContainerLabelPipe,
  ],
})
export class FreightRateBatchMarginComponent implements OnInit, OnChanges {
  private tierRepository = inject(TierRepository);

  @Input() public equipment: string[] = [];
  @Input() public freightRateGroups: Record<string, FreightRateGroup> = {};
  @Input() public selectedTier: FclTier;
  @Input() public saving = false;
  public readonly routesChange = output<Route[]>();

  public values = [];
  public containers = new ContainerPrices([]);
  public tierList: SelectItem[] = [];

  ngOnInit() {
    this.buildTierList();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.freightRateGroups) {
      this.freightRateGroups = changes.freightRateGroups.currentValue;
    }
    if (changes.equipment) {
      this.clearAbsentContainerValues();
      this.equipment = changes.equipment.currentValue;
    }
    if (changes.selectedTier) {
      if (changes.selectedTier.currentValue instanceof FclTier) {
        this.selectTier(changes.selectedTier.currentValue);
      }
    }
  }

  public selectTier(tier: FclTier): void {
    this.selectedTier = tier;
    this.equipment.forEach((containerName: ContainerName) => {
      this.values[containerName] = tier.getContainers().getPrice(containerName);
      this.containers.setPrice(
        containerName,
        tier.getContainers().getPrice(containerName),
      );
    });
  }

  public applyCustomMargin() {
    const routes: Route[] = [];
    Object.keys(this.freightRateGroups).forEach((groupKey) => {
      const group = this.freightRateGroups[groupKey];
      group.freightRates.forEach((freightRate) => {
        if (freightRate.haveRoute()) {
          const route = freightRate.getRoute();
          if (route instanceof FclRoute) {
            if (this.selectedTier) {
              // When tier is selected, we should clear all container values
              route.getContainers().setAllPrices(null);
              route.setTier(this.selectedTier);
            }

            this.equipment.forEach((containerName: ContainerName) => {
              route
                .getContainers()
                .setPrice(
                  containerName,
                  this.containers.getPrice(containerName),
                );
            });
            routes.push(route);
          }
        }
      });
    });
    if (routes.length > 0) {
      this.routesChange.emit(routes);
    }
  }

  public updateValue(event, containerName: ContainerName) {
    this.containers.setPrice(containerName, +event.target.value);
    this.selectedTier = null;
  }

  private clearAbsentContainerValues() {
    this.containers
      .getContainerPriceNames()
      .forEach((containerName: ContainerName) => {
        if (this.equipment.indexOf(containerName) === -1) {
          this.containers.setPrice(containerName, null);
        }
      });
  }

  private buildTierList() {
    this.tierList = [];

    this.tierRepository.list().subscribe((tierList) => {
      tierList.map((tier) => {
        if (tier instanceof FclTier) {
          this.tierList.push({ label: tier.getName(), value: tier });
        }
      });
    });
  }
}
